module.exports = __webpack_public_path__ + "img/seventos.b44fd03d.svg";